
export default {
  name: 'ListingMattressFinderStep',
  props: {
    step: {
      type: Object,
      default() {
        return {};
      },
    },
    currentStep: {
      type: Number,
    },
    currentInitialStepsInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    activeOption() {
      return this.currentInitialStepsInfo?.value?.join() || '';
    },
  },
  methods: {
    selectStep(attributeCode, value) {
      this.$emit('select-step', attributeCode, value);

      this.$implementOnTabbingMode(() => {
        const firstEl = this.$refs?.itemsContainer?.querySelector('[tabindex="0"]');
        firstEl?.focus();
      }, true);
    },
  },
};
